import React from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_AMBASSADOR_CERTIFICATES,
  DELETE_AMBASSADOR_CERTIFICATE,
} from "api";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { useStyles as useStylesContentList } from "ui/styles/contentList";
import DownloadButton from "components/DownloadButton";
import AmbassadorCertificateTemplate from "containers/Templates/AmbassadorCertificate";
import { getFileName } from "services/Utils";
import GroupTitle from "components/GroupTitle";

const AmbassadorCertificates: React.FC = (props) => {
  let navigate = useNavigate();
  const classesContentList = useStylesContentList();

  const editItem = (id = "skapa") => {
    navigate(`/intyg-ambassador/${id}`);
  };

  const getActionButtons = () => {
    let buttons = [];
    if (VoAuth.ability.can("update_own_ambassador_certificates", "Cert")) {
      buttons.push("edit");
    }
    if (VoAuth.ability.can("delete_own_ambassador_certificates", "Cert")) {
      buttons.push("delete");
    }
    return buttons;
  };

  const getCustomActionButtons = (row: any, index: number) => {
    return (
      <>
        <DownloadButton
          className={clsx(classesContentList.actionButton, {
            "vo-cert-download-from-list": index === 0,
          })}
          document={<AmbassadorCertificateTemplate item={row} />}
          fileName={`${getFileName([
            row && row.firstname,
            row && row.lastname,
          ])}.pdf`}
        />
      </>
    );
  };

  return (
    <>
      <Layout>
        <EnhancedTable
          enableSearch
          className="vo-global__top-bottom-space"
          title={I18n.get.ambassadorCertificate.labels.ambassadorCertificates}
          operations={{
            category: "certAmbassadorCertificates",
            get: GET_AMBASSADOR_CERTIFICATES,
            delete: DELETE_AMBASSADOR_CERTIFICATE,
          }}
          labels={{
            deleted: I18n.get.ambassadorCertificate.messages.certificateDeleted,
          }}
          columns={[
            { title: "ID", field: "id", width: 90 },
            { title: I18n.get.user.labels.firstname, field: "firstname" },
            { title: I18n.get.user.labels.lastname, field: "lastname" },
            {
              title: I18n.get.group.categories.local,
              field: "college",
              width: 200,
              render: (data) => <GroupTitle item={data?.college} />,
            },

            {
              title: I18n.get.misc.created_at,
              field: "created_at",
              width: 200,
            },
            {
              title: I18n.get.misc.updated_at,
              field: "updated_at",
              width: 200,
            },
          ]}
          addItem={
            VoAuth.ability.can("create_own_ambassador_certificates", "Cert")
              ? editItem
              : undefined
          }
          editItem={editItem}
          orderBy="UPDATED_AT"
          order="DESC"
          actionButtons={getActionButtons()}
          renderActionButtons={getCustomActionButtons}
        />
      </Layout>
    </>
  );
};

export default AmbassadorCertificates;
